import kohaImage1 from "./assets/images/koha_image1.png";
import mobileAppImage1 from './assets/images/mobile_app_image1.png';
import experianceTeam from './assets/images/experiance_team.png';
import support from './assets/images/cloudinfra.jpeg';
import trust from './assets/images/readytodeploy.jpeg';
import	AlwaysupTOdate from './assets/images/alwaysuptodate.jpeg';
import  AutoBackups from './assets/images/AutoBackups.jpeg';
import costEffective from './assets/images/dataprivacy.jpeg';
import associate1 from './assets/images/associate_image1.png';
import associate2 from './assets/images/associate_image2.png';
import associate3 from './assets/images/associate_image3.png';
import associate4 from './assets/images/associate_image4.png';
import associate5 from './assets/images/associate_image5.png';
import associate6 from './assets/images/associate_image6.png';
import { FaFacebook } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { TfiEmail } from "react-icons/tfi";
import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import mobileApp from './assets/images/mobile_app.png';
import mobileApp1 from './assets/images/mobile_app1.png';

export const icon_18 = { width: "18px", height: "18px" };
export const icon_24 = { width: "24px", height: "24px" };
export const icon_26 = { width: "26px", height: "26px" };

export const navlinks = [
    {
        title: "Home",
        path: "/",
    },
    {
        title: "Services",
        path: "/services",
        subMenu: [
            {
                title: "Koha LMS",
                path: "/services/services-koha",
            },
            {
                title: "Mobile Application",
                path: "/services/mobile-app",
            },
        ],
    },
    {
        title: "Business Associates",
        path: "/business-associates",
    },
    {
        title: "Contact Us",
        path: "/contact",
    },
];


export const services = [
    {
        title: "Cloud Hosted Koha LMS",
        desc: `Your Ready-to-Deploy, Fully Managed Library Management Platform.

LibCloud provides a pre-hosted Koha Library Management System with managed cloud infrastructure, maintenance, and technical support. Our ready-to-use platform enables business associates to offer reliable library automation services without investing in servers or managing complex technical operations.

Focus on building client relationships and growing your business while we take care of the underlying technology.`,
        path: "/services/services-koha",
        image: kohaImage1
    },
    {
        title: "Mobile Application for Koha LMS",
        desc: `Extend Your Library Services to Mobile Devices.

Offer your clients a dedicated mobile application for Koha LMS, compatible with Android and iOS. The app provides a convenient mobile interface for accessing supported library services on smartphones.

As a LibCloud business associate, you can complement your hosted Koha offering with mobile app services, expanding your portfolio while we support the underlying technology.`,
        path: "/services/mobile-app",
        image: mobileAppImage1
    }
];

export const whychoose = [
    {
        "title": "PRE-CONFIGURED KOHA",
        "desc": "Launch library services faster with our pre-configured Koha platform. Reduce setup time and technical complexity while delivering a reliable library management solution to your clients.",
        "image": experianceTeam
    },
    {
        "title": "MANAGED CLOUD INFRASRTUCTURE",
        "desc": "We manage the cloud hosting, server maintenance, and essential technical operations, allowing you to focus on client relationships and growing your library technology business.",
        "image": support
    },
    {
        "title": "READY TO DEPLOY",
        "desc": "Get started without building the infrastructure from scratch. Our deployment-ready platform helps you onboard libraries efficiently, reduce implementation effort, and expand your service portfolio.",
        "image": trust
    },
    {
        "title": "DATA PRIVACY & SECURITY",
        "desc": "We prioritise the confidentiality of your clients' library data through controlled access and responsible data handling. Build trust with a hosting partner committed to protecting your information.",
        "image": costEffective
    },
	    {
        "title": "MAINTAINED & UP-TO-DATE",
        "desc": "Keep your Koha platform maintained with technical support, security updates, and planned version upgrades. We help you maintain a dependable service while your clients focus on their library operations.",
        "image": AlwaysupTOdate
    },
    {
        "title": "AUTOMATED BACKUPS",
        "desc": "Safeguard library data with automated backups and a defined five-day retention policy. Our backup process helps protect your information and supports data recovery when required.",
        "image": AutoBackups
    }

]

export const whoCanAssociate = [
    {
        "image": associate1,
        "title": "Librarians And Library consultants"
    },
    {
        "image": associate2,
        "title": "Koha LMS Trainers"
    },
    {
        "image": associate3,
        "title": "Books And Journals Vender"
    },
    {
        "image": associate4,
        "title": "Online Databases Providers"
    },
    {
        "image": associate5,
        "title": "Educational ERP Providers"
    },
    {
        "image": associate6,
        "title": "Educational ,IT & Software Companies"
    },

]

export const benefitsOfPartnering = [
    {
        "title": "Expand",
        "desc": "Add library automation to the institutions you already serve"
    },
    {
        "title": "Earn",
        "desc": "Build predictable annual business through hosting, subscriptions and related services."
    },
    {
        "title": "Grow",
        "desc": "Offer additional technology services to your existing customer base."
    },
    {
        "title": "Brand",
        "desc": "Offer library technology under your own brand with a customized website & white-label solution."
    },
    {
        "title": "Simplify",
        "desc": "Start offering library technology without investing in servers, infrastructure or developing your own LMS."
    },
/*    {
        "title": "Dedicated Technical Support",
        "desc": "Access continuous, comprehensive support from our expert technical team whenever you need it, ensuring smooth operations."
    },
    {
        "title": "100% Data Privacy",
        "desc": "We maintain the confidentiality of your clients and business, ensuring complete peace of mind with rigorous data protection policies. "
    },
    {
        "title": "Transparent Billing",
        "desc": "Enjoy easy-to-understand and transparent billing with no hidden fees or unexpected charges."
    },
    {
        "title": "White-Label Koha LMS Application",
        "desc": "Offer a fully white-label Koha LMS application that showcases your brand and enhances your clients' experience."
    },
    {
        "title": "Mobile Application for Koha LMS",
        "desc": "Expand your offerings with the Koha LMS Mobile Application, providing your clients with a modern, mobile-friendly library solution for on-the-go access."
    },*/
];

export const social_media = [
    {
        "title": "Facebook",
        "icon": <FaFacebook style={icon_24} />,
        "link": "https://www.facebook.com",
        "color": "#3b5999"
    },
    {
        "title": "Instagram",
        "icon": <AiFillInstagram style={icon_24} />,
        "link": "https://www.instagram.com",
        "color": "#C13584"
    },

];

export const footerLinks1 = [
    {
        'title': 'About Us',
        'path': '/about',
    },
    {
        'title': 'Contact Us',
        'path': '/contact',
    },
    {
        'title': 'Business Associates',
        'path': '/business-associates',
    },
    {
        'title': 'FAQ’s',
        'path': '/faqs',
    },
];

export const footerLinks2 = [
    {
        'title': 'Terms of Service',
        'path': '/terms',
    },
    {
        'title': 'Privacy Policy',
        'path': '/privacy-policy',
    },
];

export const contact_info = [
    {
        "icon": <TfiEmail style={icon_18} />,
        "value": "business@libcloud.in"
    },
    {
        "icon": <BsTelephone style={icon_18} />,
        "value": "+91 28639465"
    },
    {
        "icon": <CiLocationOn style={icon_18} />,
        "value": "Shakti Nagar, Jabalpur, India."
    }
];

export const benefitsOfKoha = [
    {
        "title": "Uninterrupted Access",
        "desc": "Enjoy flexible access to your library system from any location, at any time, and on any device with internet connectivity. Ensure that your clients have continuous, reliable access to their library resources."
    },
    {
        "title": "No IT Infrastructure Hassles",
        "desc": "Simplify operations by eliminating the need for complex IT infrastructure or maintenance. Focus on library services instead of worrying about servers or updates."
    },
    {
        "title": "Scalable & Accessible",
        "desc": "Effortlessly scale your client’s library system as their institution grows. Ensure that all users, regardless of the library’s size, can access and utilize the system seamlessly."
    },
    {
        "title": "Pre-Defined Reports",
        "desc": "Gain valuable insights into library operations with a variety of built-in reports, tailored to your client’s institution’s needs. Streamline library management and facilitate informed decision-making."
    },
    {
        "title": "Custom OPAC",
        "desc": "Personalize the Online Public Access Catalogue (OPAC) for each client library with unique branding, including logos and institutional names, providing a professional user experience for patrons."
    },
    {
        "title": "Custom Templates",
        "desc": "Create custom templates for cataloguing, patron records, and other library workflows to ensure consistency and efficiency throughout the system."
    },
    {
        "title": "Email Notifications",
        "desc": "Set up automatic email notifications for circulation transactions, holds, payments, and more, keeping patrons and staff informed in real time."
    },
    {
        "title": "Stay Up-To-Date",
        "desc": "Stay current with automatic updates, ensuring your system has the latest features, performance improvements, and security enhancements."
    }
];

export const benefitsOfMobileApp = [
    {
        "title": "Koha Community Compatibility",
        "desc": "Ensure full compatibility and support for Koha's community versions, fostering a strong connection within the Koha ecosystem and its vast user community."
    },
    {
        "title": "Full Catalogue Search",
        "desc": "Search and explore your library's entire catalogue with powerful, comprehensive search functionality that helps users find books quickly and easily."
    },
    {
        "title": "Book Details with Image",
        "desc": "Access detailed book information, including cover images, for an enriched and visually engaging browsing experience while discovering new titles."
    },
    {
        "title": "Book Availability Details",
        "desc": "Instantly check the availability of books in your library’s collection. Plan your borrowing efficiently and know when your desired books are available."
    },
    {
        "title": "Personalized User Login",
        "desc": "Allow users to log in to the app and personalize their experience. Tailor the Online Public Access Catalog (OPAC) with your library’s logo and name for a branded experience."
    },
    {
        "title": "User Information Access",
        "desc": "Empower users to conveniently view their current holdings, payment history, and past reading activity within the app, providing easy access to essential information."
    },
    {
        "title": "Book Reservation",
        "desc": "Reserve books directly through the mobile app, ensuring you never miss out on the books you want to read next."
    },
    {
        "title": "Notifications",
        "desc": "Receive timely reminders for overdue books and other important notifications, helping users stay organized and informed about their library activities."
    },
];

export const mobileAppOptions = [
    {
        "title": "Standard Layout",
        "image": mobileApp,
        "steps": [
            "Search for LibCloud on google play store",
            "Download",
            "Scan QR",
            "App is ready"
        ]
    },
    {
        "title": "Custom Layout",
        "image": mobileApp1,
        "steps": [
            "App in institute name on google play store",
            "Download",
            "App is ready"
        ]
    }
];

export const faqQuestions = [
    {
        "question": "Why should I get associated with Libcloud?",
        "answer": "Many reasons and benefits exist for associating with Libcloud. You can explore details at http://site.libcloud.in/business-associates ."
    },
    {
        "question": "Are there any setup fees for becoming a business associate?",
        "answer": "No, there are no additional setup fees beyond the subscription cost."
    },
    {
        "question": "Can I rebrand the Koha LMS as my own?",
        "answer": "Yes, we offer white-labeling options so you can rebrand the LMS to align with your business identity."
    },
    {
        "question": "What services will I receive as a business associate?",
        "bullets": [
            "Pre-installed Koha LMS and mobile application.",
            "The Koha application will be set up within 6 hours of receiving payment."
        ]
    },
    {
        "question": "What client details are required by Libcloud?",
        "answer": "Only the client's name is required. No additional information is necessary to configure the Koha LMS."
    },

    {
        "question": "How secure is my client's information?",
        "answer": "We ensure 100% security of client information.",
        "bullets": [
            "We can sign an NDA to guarantee confidentiality.",
            "Client data is not shared with anyone except the data owner."
        ]
    },
    {
        "question": "Do my clients have access to Libcloud's support team?",
        "answer": "No, we do not interact with your clients directly."
    },
    {
        "question": "Do I have access to Libcloud's support team?",
        "answer": "Yes, as a business associate, you will have access to a dedicated support team to resolve any issues."
    },
    {
        "question": "What happens if I need support outside of working hours?",
        "answer": "You can drop an email, and we will respond as soon as possible."
    },
    {
        "question": "Is there any limit on support calls or emails?",
        "answer": 'There are absolutely no limits on support calls or emails.'
    },
    {
        "question": "Can a library directly subscribe to services from Libcloud?",
        "answer": "No, services are provided exclusively through business associates."
    },
    {
        "question": "Can I get custom reports for my clients?",
        "answer": "Yes, we can create reports tailored to your requirements."
    },
    {
        "question": "How many reports are included in the package?",
        "answer": "Unlimited reports are included as part of the package."
    },
    {
        "question": "How often can OPAC be customized?",
        "answer": "OPAC can be customized unlimited times."
    },
    {
        "question": "Is Koha version upgrade included in the package?",
        "answer": "Yes, version upgrades are included as part of the subscription."
    },
    {
        "question": "Who will provide training to clients?",
        "answer": "Libcloud does not provide training directly to your clients."
    },

    {
        "question": "How can I access a backup of my client’s data?",
        "answer": "The backup option is available on the Koha dashboard and can be downloaded anytime.."
    },
    {
        "question": "Can I integrate third-party tools with the Koha LMS?",
        "answer": "Yes, we support integration with third-party tools such as RFID, SSO, and ERP systems as per your client's requirements. These services are chargeable."
    },
    {
        "question": "What if my client wants to migrate data from another LMS?",
        "answer": "We do not offer data migration services."
    },
    {
        "question": "How many business associates currently work with Libcloud?",
        "answer": "As per our policy, we do not disclose this information. However, more than 500 Koha users are utilizing our services."
    },
    {
        "question": "What happens if I want to cancel my association?",
        "answer": "You can cancel your subscription at any time. However, data access and services will be available until the end of the current billing cycle."
    },
];


